<template>
  <SlideYUpTransition :duration="animationDuration">
    <b-modal
      class="modal fade"
      ref="app-modal"
      :size="size"
      :no-close-on-esc="noCloseOnEsc"
      :no-close-on-backdrop="noCloseOnBackdrop"
      :hide-header="!$slots.header"
      :hide-footer="!$slots.footer"
      :modal-class="[{ 'modal-mini': type === 'mini' }, ...modalClasses]"
      @mousedown.self="closeModal"
      tabindex="-1"
      role="dialog"
      centered
      @close="closeModal"
      @hide="closeModal"
      :header-class="headerClasses"
      :footer-class="footerClasses"
      :content-class="[
        gradient ? `bg-gradient-${gradient}` : '',
        ...modalContentClasses,
      ]"
      :body-class="bodyClasses"
      :aria-hidden="!show"
    >
      <template v-slot:modal-header>
        <slot name="header"></slot>
        <slot name="close-button">
          <button
            type="button"
            class="close"
            v-if="showClose"
            @click="closeModal"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span :aria-hidden="!show">×</span>
          </button>
        </slot>
      </template>

      <slot />

      <template v-slot:modal-footer>
        <slot name="footer"></slot>
      </template>
    </b-modal>
  </SlideYUpTransition>
</template>
<script>
import { SlideYUpTransition } from 'vue2-transitions'

export default {
  name: 'modal',

  components: {
    SlideYUpTransition,
  },

  props: {
    show: Boolean,
    showClose: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: '',
      validator(value) {
        let acceptedValues = ['', 'notice', 'mini']
        return acceptedValues.indexOf(value) !== -1
      },
      description: 'Modal type (notice|mini|"") ',
    },
    modalClasses: {
      type: [Object, String],
      description: 'Modal dialog css classes',
    },
    size: {
      type: String,
      description: 'Modal size',
      validator(value) {
        let acceptedValues = ['', 'sm', 'lg', 'xl']
        return acceptedValues.indexOf(value) !== -1
      },
    },
    modalContentClasses: {
      type: [Object, String],
      description: 'Modal dialog content css classes',
    },
    gradient: {
      type: String,
      description: 'Modal gradient type (danger, primary etc)',
    },
    headerClasses: {
      type: [Object, String],
      description: 'Modal Header css classes',
    },
    bodyClasses: {
      type: [Object, String],
      description: 'Modal Body css classes',
    },
    footerClasses: {
      type: [Object, String],
      description: 'Modal Footer css classes',
    },
    animationDuration: {
      type: Number,
      default: 500,
      description: 'Modal transition duration',
    },
    noCloseOnEsc: {
      type: Boolean,
      default: false,
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    closeModal() {
      this.$emit('update:show', false)
      this.$emit('close')
    },

    // THIS BLOCKS THE BACK BUTTON TO GO BACK
    onDeviceReady() {
      ;(function (global) {
        if (typeof global === 'undefined') {
          throw new Error('window is undefined')
        }

        var _hash = '!'
        var noBackPlease = function () {
          global.location.href += '#'

          // Making sure we have the fruit available for juice (^__^)
          global.setTimeout(function () {
            global.location.href += '!'
          }, 50)
        }

        global.onhashchange = function () {
          if (global.location.hash !== _hash) {
            global.location.hash = _hash
          }
        }

        global.onload = function () {
          noBackPlease()

          // Disables backspace on page except on input fields and textarea..
          document.body.onkeydown = function (e) {
            var elm = e.target.nodeName.toLowerCase()
            if (e.which === 8 && elm !== 'input' && elm !== 'textarea') {
              e.preventDefault()
              this.$emit('update:show', false)
              this.$emit('close')
            }
            // Stopping the event bubbling up the DOM tree...
            e.stopPropagation()
          }
        }
      })(window, this)
    },
  },

  watch: {
    show(val) {
      if (val) {
        this.$refs['app-modal'].show()
      } else {
        this.$refs['app-modal'].hide()
      }
    },
  },

  mounted() {
    this.onDeviceReady()
  },
}
</script>
<style>
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

/* .modal-content {
  max-height: 94vh;
} */
.modal-body {
  overflow-y: auto;
}
</style>
